export const USER_SETTING_SECTION_TITLE = {
  profile: "プロフィール",
  notification: "通知設定",
  seal: "請求書確認押印名",
} as const;

export const USER_SETTING_SECTION_ID = {
  profile: "user-setting-profile",
  notification: "user-setting-notification",
  seal: "user-setting-seal",
} as const;

/** Design measurements: two columns total 1134px = nav 258 + gap 24 + content 852. */
export const USER_SETTING_LAYOUT_WIDTH = 1134;
export const USER_SETTING_NAV_WIDTH = 258;
export const USER_SETTING_CONTENT_WIDTH = 852;
export const USER_SETTING_COLUMN_GAP = 24;

export const NOTIFICATION_SETTING_DESCRIPTION = "デフォルトでは全て通知に設定されています。個別に設定したい場合は「個別メール通知」から設定できます。";

export const PROFILE_SETTING_DESCRIPTION = "メールアドレス変更、パスワード変更後は再読み込みボタンで更新してください。";
